import React from "react";

const BellIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_5838_8070)">
        <path
          d="M54.7487 46.8832L54.182 46.3832C52.5744 44.9509 51.1673 43.3083 49.9987 41.4999C48.7224 39.0042 47.9574 36.2786 47.7487 33.4832V25.2499C47.7597 20.8593 46.1671 16.6157 43.2699 13.3165C40.3728 10.0174 36.3706 7.88969 32.0154 7.33325V5.18325C32.0154 4.59315 31.7809 4.02721 31.3637 3.60994C30.9464 3.19267 30.3805 2.95825 29.7904 2.95825C29.2003 2.95825 28.6343 3.19267 28.2171 3.60994C27.7998 4.02721 27.5654 4.59315 27.5654 5.18325V7.36658C23.2491 7.96313 19.2953 10.1037 16.4362 13.3918C13.5772 16.6798 12.0066 20.8927 12.0154 25.2499V33.4832C11.8066 36.2786 11.0417 39.0042 9.76536 41.4999C8.61683 43.3038 7.23236 44.9461 5.6487 46.3832L5.08203 46.8832V51.5832H54.7487V46.8832Z"
          fill={fill}
        />
        <path
          d="M25.5352 53.3333C25.6813 54.3897 26.2048 55.3576 27.009 56.0582C27.8131 56.7588 28.8436 57.1447 29.9102 57.1447C30.9767 57.1447 32.0072 56.7588 32.8113 56.0582C33.6155 55.3576 34.139 54.3897 34.2852 53.3333H25.5352Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5838_8070">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

BellIcon.defaultProps = {
  width: 60,
  height: 60,
  fill: "#D1CECE",
};

export default BellIcon;
